import dayjs from 'dayjs'
import { UsersTechnology } from '../index'
import { WorkingMethod } from '../enums/WorkingMethod'
import { Option } from '../../../components/Form/Inputs/AutocompleteInput'

export type CandidateFormValues = {
  firstName: string
  lastName: string
  email: string
  phoneNumber: string
  localization: string
  domicile: string
  workingMethod: WorkingMethod
  cv: string
  repository: string
  dateOfApplication: dayjs.Dayjs | undefined
  description: string
  comment?: string
  responsibles?: Option[]
  technologies: UsersTechnology[]
  version: number
}

export const defaultCandidateFormValues: CandidateFormValues = {
  firstName: '',
  lastName: '',
  email: '',
  phoneNumber: '',
  localization: '',
  domicile: '',
  workingMethod: WorkingMethod.STATIONARY,
  cv: '',
  repository: '',
  dateOfApplication: dayjs().utc(true),
  description: '',
  comment: '',
  responsibles: [],
  technologies: [],
  version: 1,
}